import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="star-rating"
export default class extends Controller {
  static targets = ["star", "input"]
  static values = { rating: Number }

  connect() {
    this.selectedRating = this.ratingValue || 0
    this.updateStarDisplay()
  }

  selectRating(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.selectedRating = rating
    this.inputTarget.value = rating
    this.updateStarDisplay()
  }

  hoverRating(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.highlightStars(rating)
  }

  resetHover() {
    this.updateStarDisplay()
  }

  highlightStars(rating) {
    this.starTargets.forEach((star, index) => {
      if (index < rating) {
        star.classList.remove('text-gray-300')
        star.classList.add('text-yellow-400')
      } else {
        star.classList.remove('text-yellow-400')
        star.classList.add('text-gray-300')
      }
    })
  }

  updateStarDisplay() {
    this.highlightStars(this.selectedRating)
  }
}